import { createGlobalStyle, keyframes } from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import { Theme } from 'lib/ui/types'
import { CSS_CLASS } from '../../constants'
import { BP } from 'resources/constants'

export const fadeInKeyframes = keyframes`
  0% {
    opacity: 0.5;
    top: 10%;
  }

  100% {
    opacity: 1;
    top: 50%;
  }
`

export const ModalGlobalStyle = createGlobalStyle<{ theme: Theme }>`
  .${CSS_CLASS.REMOVE_SCROLL},
  .${CSS_CLASS.REMOVE_SCROLL} body {
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .${CSS_CLASS.OVERLAY},
  .${CSS_CLASS.OVERLAY_CLEAR} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99993;
    backface-visibility: hidden;
  }

  .${CSS_CLASS.MODAL} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    outline: none;
    white-space: normal;
    box-sizing: border-box;
    text-align: center;
    z-index: 99994;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: transparent;
    pointer-events: none;

    &::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      height: 100%;
      width: 0;
    }
  }

  .${CSS_CLASS.CONTENT_WRAP} {
    display: inline-block;
    position: relative;
    padding: 0;
    margin: 1rem 0;
    border: 4px solid ${props => props.theme.palette.general.grey};
    vertical-align: middle;
    text-align: left;
    overflow: auto;
    box-sizing: border-box;
    width: 90%;
    pointer-events: visible;
    border-radius: 0;
    background: ${props => props.theme.palette.general.light} no-repeat 50% 50% / cover;

    @media (min-width: ${BP.sm.min}) {
      width: 500px;
      margin: 3rem auto;
    }

    @media (min-width: ${BP.md.min}) {
      width: 600px;
    }
  }

  .${CSS_CLASS.OVERLAY} {
    background-color: rgba(0, 0, 0, 0.55);
  }

  .${CSS_CLASS.HEADER} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    position: relative;

    h3 {
      margin: 0;
      font: ${font('default', 'normal', '18px/1.2')};
      padding-right: 50px;
    }

    .${CSS_CLASS.CLOSE} {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      padding: 0 20px;
    }
  }

  .${CSS_CLASS.CLOSE} {
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    width: auto;
    line-height: 1;
    transition: all ease-in-out 0.3s;

    &:hover,
    &:focus {
      opacity: 0.5;
    }

    > svg {
      width: 6px;
      position: relative;
      top: 2px;
      padding: 3px;
      border: 1px solid;
    }
  }

  .${CSS_CLASS.CONTENT} {
    position: relative;
    padding: 20px;
    max-height: 70vh;
    overflow: auto;
  }
`
